import CardStatus from './CardStatus';

export default CardStatus;
